import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const AllTopics = lazy(() => import('./AllTopics'))
const SingleTopic = lazy(() => import('./Components/TopicSingleView/TopicSingleView'))

const AllTopicsRoutes = [
    {
        path: '/all_topics',
        component: AllTopics,
        auth: authRoleAccess.allUsers,
    },
    {
        path: '/single_topic/:id',
        component: SingleTopic,
        auth: authRoleAccess.allUsers,
    },
]

export default AllTopicsRoutes 